export default __webpack_public_path__ + "static/media/caashbeneficiario.842f4211.jpg";